import React from "react";

function Testimonials() {
  return (
    <>
      {/*  Testimonial End **/}
      <div className="section section-padding-02 mt-n1">
        <div className="container">
          {/*  Section Title Start **/}
          <div className="section-title shape-03 text-center">
            <h5 className="sub-title">Student Testimonial</h5>
            <h2 className="main-title">
              Feedback From <span> Student</span>
            </h2>
          </div>
          {/*  Section Title End **/}

          {/*  Testimonial Wrapper End **/}
          <div className="testimonial-wrapper testimonial-active">
            <div className="swiper-container">
              <div className="swiper-wrapper">
                {/*  Single Testimonial Start **/}
                <div className="single-testimonial swiper-slide">
                  <div className="testimonial-author">
                    <div className="author-thumb">
                      <img
                        src="assets/images/author/author-15.jpg"
                        alt="Author"
                      />

                      <i className="icofont-quote-left"></i>
                    </div>

                    <span className="rating-star">
                      <span className="rating-bar"></span>
                    </span>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      Techi Jack is amazing. I took a project to deploy Exchange
                      servers to 5 locations. I ran into an issue and couldn't
                      resolve. I got in contact with Techi Jack, he helped me
                      resolve that issue and deploy the rest flawlessly. I had
                      min to no knowledge on Exchange. With his sincere help and
                      support, I am trained enough to do it on my own with out
                      any issues. Thank You Techi Jack for being a blessing. If
                      anyone need any support with AD / Exchange / O365. Techi
                      Jack is a one stop shop.
                    </p>
                    <h4 className="name">Mustafa Ali Khan </h4>
                    <span className="designation">Dallas, Texas</span>
                  </div>
                </div>
                {/*  Single Testimonial End **/}
         
              </div>

              {/*  Add Pagination **/}
              <div className="swiper-pagination"></div>
            </div>
          </div>
          {/*  Testimonial Wrapper End **/}
        </div>
      </div>
      {/*  Testimonial End **/}
    </>
  );
}

export default Testimonials;
